import { render, staticRenderFns } from "./transferDialog.vue?vue&type=template&id=c24b8fbc&scoped=true"
import script from "./transferDialog.vue?vue&type=script&lang=js"
export * from "./transferDialog.vue?vue&type=script&lang=js"
import style0 from "./transferDialog.vue?vue&type=style&index=0&id=c24b8fbc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24b8fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24b8fbc')) {
      api.createRecord('c24b8fbc', component.options)
    } else {
      api.reload('c24b8fbc', component.options)
    }
    module.hot.accept("./transferDialog.vue?vue&type=template&id=c24b8fbc&scoped=true", function () {
      api.rerender('c24b8fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/transferDialog.vue"
export default component.exports